import ThumbnailStep from './ThumbnailStep';
export default ThumbnailStep;